let o = null;
function i() {
  if (o === null && (o = document.getElementById("v-binder-view-measurer"), o === null)) {
    o = document.createElement("div"), o.id = "v-binder-view-measurer";
    const { style: t } = o;
    t.position = "fixed", t.left = "0", t.right = "0", t.top = "0", t.bottom = "0", t.pointerEvents = "none", t.visibility = "hidden", document.body.appendChild(o);
  }
  return o.getBoundingClientRect();
}
function c(t, e) {
  const n = i();
  return {
    top: e,
    left: t,
    height: 0,
    width: 0,
    right: n.width - t,
    bottom: n.height - e
  };
}
function f(t) {
  const e = t.getBoundingClientRect(), n = i();
  return {
    left: e.left - n.left,
    top: e.top - n.top,
    bottom: n.height + n.top - e.bottom,
    right: n.width + n.left - e.right,
    width: e.width,
    height: e.height
  };
}
function u(t) {
  return t.nodeType === 9 ? null : t.parentNode;
}
function d(t) {
  if (t === null)
    return null;
  const e = u(t);
  if (e === null)
    return null;
  if (e.nodeType === 9)
    return document;
  if (e.nodeType === 1) {
    const { overflow: n, overflowX: r, overflowY: l } = getComputedStyle(e);
    if (/(auto|scroll|overlay)/.test(n + l + r))
      return e;
  }
  return d(e);
}
export {
  i as ensureViewBoundingRect,
  u as getParentNode,
  c as getPointRect,
  f as getRect,
  d as getScrollParent
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/binder/src/utils.js
// module id = 988
// module chunks = 67